"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect } from "react";
import { textColorPicker } from "utils/helpers/TextColorPicker";
import hexToHsl from "utils/helpers/hexToHsl";
function ColorProvider(t0) {
  const $ = _c(3);
  const {
    children,
    color
  } = t0;
  let t1;
  let t2;
  if ($[0] !== color) {
    t1 = () => {
      if (color) {
        const hslColor = hexToHsl(color);
        document.documentElement.style.setProperty("--theme-color", `hsl(${hslColor})`);
        const hslTextColor = hexToHsl(textColorPicker(color));
        document.documentElement.style.setProperty("--theme-text-color", `hsl(${hslTextColor})`);
      }
    };
    t2 = [color];
    $[0] = color;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return children;
}
export default ColorProvider;